<div class="btn-group" dropdown>
    <a href="javascript:void(0)" aria-controls="dropdown-visbility" dropdownToggle class="kv-header-notification"
        id="dropdownNotification" data-toggle="dropdown">
        <svg id="Capa_1" enable-background="new 0 0 479.058 479.058" height="17" viewBox="0 0 479.058 479.058"
            width="17" xmlns="http://www.w3.org/2000/svg">
            <path
                d="m434.146 59.882h-389.234c-24.766 0-44.912 20.146-44.912 44.912v269.47c0 24.766 20.146 44.912 44.912 44.912h389.234c24.766 0 44.912-20.146 44.912-44.912v-269.47c0-24.766-20.146-44.912-44.912-44.912zm0 29.941c2.034 0 3.969.422 5.738 1.159l-200.355 173.649-200.356-173.649c1.769-.736 3.704-1.159 5.738-1.159zm0 299.411h-389.234c-8.26 0-14.971-6.71-14.971-14.971v-251.648l199.778 173.141c2.822 2.441 6.316 3.655 9.81 3.655s6.988-1.213 9.81-3.655l199.778-173.141v251.649c-.001 8.26-6.711 14.97-14.971 14.97z" />
        </svg>
        <span *ngIf="supportRequestCount > 0"
            class="badge badge-light notification-badge">{{supportRequestCount}}</span>
        </a>
    <div class="dropdown-menu popup-z-index" id="dropdown-visbility" aria-labelledby="dropdownNotification">
        <ng-container *ngIf="supportRequestCount == 0">
            <a class="dropdown-item" href="javascript:void(0)">No Notification Found.</a>
        </ng-container>
        <div class="notification-section popup-z-index">
            <div class="notifications" *ngIf="data?.length > 0">
                <ul>
                    <ng-container *ngFor="let item of data">
                        <li [routerLink]="['/support-requests/internal' ,item?.internalSupportRequestId]">
                            <h6>{{item?.title}}</h6>
                            <small>{{item?.createdDate}} &nbsp;</small>
                            <small>{{item?.createdByName}}</small>
                        </li>
                    </ng-container>
                </ul>
            </div>
        </div>
    </div>
</div>